<template>
    <div class="app-container">
        <el-form :inline="true" ref="form" :model="form" label-width="100px">
            <div class="filters-wrap clearfix">
                <div class="filters-action">
                    <el-button type="primary" size="small" @click="queryUserMessage">搜索</el-button>
                    <el-button size="small" @click="clear('form')">清空</el-button>
                </div>
                <div class="filters-area">
                    <el-row>

                        <el-col :span="8">
                            <el-form-item label="正文" prop="content">
                                <el-input :maxlength="100" v-model.trim="params.queryParamList[0].value" size="small" placeholder="请输入正文"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--<el-row>-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item label="发送日期">-->
                                <!--<el-date-picker-->
                                        <!--v-model="params.queryParamList[2].items"-->
                                        <!--type="daterange"-->
                                        <!--:clearable="false"-->
                                        <!--range-separator="至"-->
                                        <!--start-placeholder="开始日期"-->
                                        <!--end-placeholder="结束日期"-->
                                        <!--value-format="yyyy-MM-dd"-->
                                        <!--format="yyyy-MM-dd"-->
                                        <!--align ="center">-->
                                <!--</el-date-picker>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item label="创建日期">-->
                                <!--<el-date-picker-->
                                        <!--v-model="params.queryParamList[3].items"-->
                                        <!--type="daterange"-->
                                        <!--:clearable="false"-->
                                        <!--range-separator="至"-->
                                        <!--start-placeholder="开始日期"-->
                                        <!--end-placeholder="结束日期"-->
                                        <!--value-format="yyyy-MM-dd"-->
                                        <!--format="yyyy-MM-dd"-->
                                        <!--align ="center">-->
                                <!--</el-date-picker>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->

                </div>
            </div>
        </el-form>
        <div class="page-grid">
            <div class="table-group">
                <el-button size="small" @click="updateMessageIsRead()">指定已读消息</el-button>
                <egrid class="egrid" stripe fit border highlight-current-row  v-loading="loading" element-loading-text="正在努力加载中..." :column-type="['selection', 'index']" ref="eltable"
                       :data="tableData" :columns="columns" :columns-schema="columnsSchema"  @selection-change="checkIds">
                </egrid>
            </div>

            <epagination :total="total" :current="currentPage" @change="getPages" :page-sizes="[25,50,100,200]" v-if="tableData"></epagination>
        </div>

    </div>
</template>


<script>
    import listMixins from '@/mixins/list'
    import systemTag from './systemTag'
    import isReadTag from './isReadTag'

    export default {
        mixins:[listMixins],

        data() {
            return {
                form: {
                    id: '',
                    userId: '',
                    userName: '',
                    title: '',
                    content: '',
                    system: '',
                    linkUrl: '',
                    sendTime: '',
                    createTime: '',
                },
                systems:this.$cache.getDic("role_type"),
                params: {
                    page: 1,
                    pageSize: this.$cache.getConfig("list_page_default_pagesize"),
                    orderBy: "id desc",
                    totalRows: 0,
                    export: false,
                    queryParamList: [
                        {field: "content",type: "string" ,logic: "like" , value:'',items: []},
                        // {field: "system",type: "string" ,logic: "like" , value:'0',items: []},
                        // {field: "sendTime",type: "string" ,logic: "like" , value:'',items: []},
                        // {field: "createTime",type: "string" ,logic: "like" , value:'',items: []},
                    ]
                },
                paramsBack: {
                    page: 1,
                    pageSize: this.$cache.getConfig("list_page_default_pagesize"),
                    orderBy: "id desc",
                    totalRows: 0,
                    export: false,
                    queryParamList: [
                        {field: "system",type: "string" ,logic: "like" , value:'0',items: []},
                    ]
                },
                // 表格列
                columns: [

                    {
                        label: '接收用户名称',
                        prop: 'userName',
                        align: 'center',
                    },
                    {
                        label: '是否已读',
                        prop: 'isRead',
                        align: 'center',
                    },
                    {
                        label: '标题',
                        prop: 'title',
                        align: 'center',
                    },
                    {
                        label: '正文',
                        prop: 'content',
                        align: 'center'
                    },
                    {
                        label: '所属端',
                        prop: 'system',
                        align: 'center'
                    },
                    {
                        label: '跳转链接',
                        prop: 'linkUrl',
                        align: 'center'
                    },
                    {
                        label: '发送时间',
                        prop: 'sendTime',
                        align: 'center',
                         formatter: this.filterDate
                    },
                    {
                        label: '创建时间',
                        prop: 'createTime',
                        align: 'center',
                        formatter: this.filterDate
                    },
                ],
                columnsSchema:{
                    'system': {
                        width: 'auto',
                        // propsHandler 可用于转换传给自定义组件的 props
                        propsHandler({ col, row }) {

                            return { system: row[col.prop] }
                        },
                        component: systemTag
                    },

                    'isRead': {
                        width: 'auto',
                        // propsHandler 可用于转换传给自定义组件的 props
                        propsHandler({ col, row }) {

                            return { isRead: row[col.prop] }
                        },
                        component: isReadTag
                    },
                  'content': {
                    propsHandler({col, row}) {
                      return {row: row[col.prop]}
                    },
                    component: 'popShow'
                  },
                },
            }
        },
        created() {
            this.initTableData(this.$api.BusiMessage.queryUser, this.params);
            /*this.$fetchData(this.$api.BusiMessage.queryUser,this.paramsBack,'post')
                .then(res => {
                    this.loading = false
                    if (res.totalRows != undefined) {
                        this.total = res.totalRows
                    }
                    this.tableData = res.content
                    this.state = true
                }).catch(error => {
                this.loading = false
                this.state = false
            })*/
        },
        methods:{
            clear(){
                for (const key in this.params.queryParamList) {
                    this.params.queryParamList[key].value = ''
                    this.params.queryParamList[key].items = []
                }
            },
            queryUserMessage() {
                this.params.queryParamList[1].value = '0'
                this.$fetchData(this.$api.BusiMessage.queryPageUser, this.params,'post')
                    .then(res => {
                        this.loading = false
                        if (res.totalRows != undefined) {
                            this.total = res.totalRows
                        }
                        this.tableData = res.content
                        this.state = true
                    }).catch(error => {
                    this.loading = false
                    this.state = false
                })
            },
            updateMessageIsRead(){
                if (!this.ids.length) {
                    this.$message.error('您还没有选择数据')
                    return
                }

                this.$fetchData(this.$api.BusiMessage.backUpdateIsReadBusiMessage, this.ids,'post')
                    .then(res => {

                        this.$fetchData(this.$api.BusiMessage.queryUser,this.paramsBack,'post')
                            .then(res => {
                                this.loading = false
                                if (res.totalRows != undefined) {
                                    this.total = res.totalRows
                                }
                                this.tableData = res.content
                                this.state = true
                            }).catch(error => {
                            this.loading = false
                            this.state = false
                        })
                    }).catch(error => {

                })
            }
        },
    }

</script>
